import React, { useState } from 'react'
import cn from 'classnames'
import Button from '@material-ui/core/Button'
import { withStyles } from '@material-ui/core/styles'
import ArrowBackIcon from '@material-ui/icons/ArrowBack'
import advanced1 from './a1.png'
import advanced2 from './a2.png'
import advanced3 from './a3.png'
import advanced4 from './a4.png'
import basic1 from './b1.png'
import basic2 from './b2.png'
import styles from './styles'

const CodeExplanation = ({ classes, onClose }) => {
  const [activeType, setActiveType] = useState('BASIC')

  return (
    <div className={classes.block}>
      <div className={classes.title}>
        <div className={classes.backButton} onClick={onClose}>
          <ArrowBackIcon />
        </div>
        <div className={classes.titleText}>
          What are codes and why do I need to provide them?
        </div>
      </div>
      <div className={classes.buttons}>
        <Button
          className={cn(
            classes.button,
            activeType === 'BASIC' ? classes.filledButton : '',
          )}
          onClick={() => setActiveType('BASIC')}
          variant="contained"
        >
          Basic Tracking
        </Button>
        <Button
          className={cn(
            classes.button,
            activeType === 'ADVANCE' ? classes.filledButton : '',
          )}
          variant="outlined"
          onClick={() => setActiveType('ADVANCE')}
        >
          Advance Tracking
        </Button>
      </div>
      <div className={classes.codesTitle}>
        {activeType === 'BASIC' ? 'Basic Tracking' : 'Advance Tracking'}
      </div>
      {activeType === 'BASIC' ? (
        <div className={classes.tipsBlock}>
          <div className={classes.tipBlock}>
            <div className={classes.tipNumber}>1</div>
            <div className={classes.tipInfo}>
              <div className={classes.tipMessage}>
                You don’t have the capacity to provide unique codes for each
                mission, but can provide one code for the entire campaign.
              </div>
              <img
                src={basic1}
                className={classes.tipImage}
                alt="basic type tip 1"
              />
            </div>
          </div>
          <div className={classes.tipBlock}>
            <div className={classes.tipNumber}>2</div>
            <div className={classes.tipInfo}>
              <div className={classes.tipMessage}>
                We are still able to track individual performance using our
                proprietary technlology and vast number of spies, but at lesser
                accuracy.
                <br />
                Since every brand ambassador will be distributing the same code,
                we can not know what their individual conversions results are.
              </div>
              <img
                src={basic2}
                className={classes.tipImage}
                alt="basic type tip 2"
              />
            </div>
          </div>
        </div>
      ) : (
        <div className={classes.tipsBlock}>
          <div className={classes.tipBlock}>
            <div className={classes.tipNumber}>1</div>
            <div className={classes.tipInfo}>
              <div className={classes.tipMessage}>
                You are able to generate a unique code for each mission in your
                campaign and provide us with conversion results for these as the
                campaign is running. The codes are the individual for each
                mission (each flyer pack).
              </div>
              <img
                src={advanced1}
                className={classes.tipImage}
                alt="advanced type tip 1"
              />
            </div>
          </div>
          <div className={classes.tipBlock}>
            <div className={classes.tipNumber}>2</div>
            <div className={classes.tipInfo}>
              <div className={classes.tipMessage}>
                For this campaign, we will need codes, as well as a link to a
                website or landing page that the user sees when they scan the QR
                code on your flyer with their phone.
              </div>
              <img
                src={advanced2}
                className={classes.tipImage}
                alt="advanced type tip 2"
              />
            </div>
          </div>
          <div className={classes.tipBlock}>
            <div className={classes.tipNumber}>3</div>
            <div className={classes.tipInfo}>
              <div className={classes.tipMessage}>
                By providing us with unique codes, we are able to gain deep
                insight into how each mission is performing and accurately track
                our brand ambassadors.
              </div>
              <img
                src={advanced3}
                className={classes.tipImage}
                alt="advanced type tip 3"
              />
            </div>
          </div>
          <div className={classes.tipBlock}>
            <div className={classes.tipNumber}>4</div>
            <div className={classes.tipInfo}>
              <div className={classes.tipMessage}>
                This further helps us to optimise your campaign by continually
                re-evaluting what days, times and locations generate the highest
                results for you.
              </div>
              <img
                src={advanced4}
                className={classes.tipImage}
                alt="advanced type tip 4"
              />
            </div>
          </div>
        </div>
      )}
    </div>
  )
}

export default withStyles(styles)(CodeExplanation)
